import Header from "../Components/Header/Header";
import { FileText, Calendar, Users, Award, Code, Layout, Briefcase } from 'lucide-react';
import './Regulation.css';

const Regulation = () => {
  return (
    <div className="Page">
      <Header />
      
      <div className="regulation-container">
        <div className="regulation-header">
          <FileText className="header-icon" size={40} />
          <h1>Положение о мероприятии "Сатурнский Хакатон 2025 - 3 поток"</h1>
        </div>

        <div className="regulation-content">
          <div className="regulation-section">
            <h2><FileText size={20} className="section-icon" /> Общие положения</h2>
            <ul>
              <li>Мероприятие «Сатурнский Хакатон 2025» проводится для школьников Олёкминского района с 7 - 11 класс.</li>
              <li>Хакатон будет проводиться в очном формате на базе МБОУ Районной Гимназии «Эврика»</li>
              <li>Мероприятие направлено на укрепление командного духа и развитие проектной деятельности участников</li>
            </ul>
          </div>

          <div className="regulation-section">
            <h2><Award size={20} className="section-icon" /> Цель конкурса</h2>
            <ul>
              <li>Разработать прототип проекта, решающий определенную проблему в городе или районе</li>
              <li>Уделить основное внимание развитию IT-сферы в Якутии, не ориентируясь на крупный рынок</li>
              <li>Мотивировать участников на создание проектов, способствующих развитию IT-инфраструктуры региона</li>
            </ul>
          </div>

          <div className="regulation-section">
            <h2><Calendar size={20} className="section-icon" /> Продолжительность</h2>
            <p>Мероприятие продлится с 1 - 8 августа 2025 года, включая работу над проектом и презентацию результатов</p>
          </div>

          <div className="regulation-section">
            <h2><Users size={20} className="section-icon" /> Участие и команды</h2>
            <ul>
              <li>Участниками являются школьники с 7 - 11 класс.</li>
              <li>Каждая команда состоит из 3 человек:
                <ul className="role-list">
                  <li><Briefcase size={16} /> Менеджер</li>
                  <li><Layout size={16} /> Дизайнер</li>
                  <li><Code size={16} /> Разработчик</li>
                </ul>
              </li>
              <li>Команды должны зарегистрироваться заранее, предоставив информацию об участниках и контактные данные</li>
            </ul>
          </div>

          <div className="regulation-section">
            <h2><FileText size={20} className="section-icon" /> Задачи и оценка</h2>
            <ul>
              <li>Команды должны разработать проект, решающий проблему заказчика.</li>
              <li>Проекты будут оцениваться по следующим критериям:
                <ul>
                  <li>Инновационность</li>
                  <li>Выполнение задачи</li>
                  <li>Техническая реализация</li>
                  <li>Качество презентации</li>
                  <li>Командная работа</li>
                </ul>
              </li>
              <li>Победители будут выбраны на основе общей оценки каждой команды, предоставленной жюри</li>
            </ul>
          </div>

          <div className="regulation-section">
            <h2><Award size={20} className="section-icon" /> Награды</h2>
            <ul>
              <li>Лучшие команды получат дипломы и возможность участия в тех-инкубаторе «Сатурн.ТехПром»</li>
              <li>Все участники получат сертификаты участия</li>
            </ul>
          </div>

          <div className="regulation-organizers">
            <h2>Организаторы и партнеры</h2>
            <div className="organizers-grid">
              <div className="organizer-card">
                <h3>Организатор</h3>
                <p>АНО «Центр Цифровой Трансформации «Горизонт Сатурна» РС(Я)</p>
              </div>
              <div className="organizer-card">
                <h3>Партнеры</h3>
                <p>Скоро..</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Regulation;